import { createFileRoute } from "@tanstack/react-router";
import Admin from "@/pages/Admin";
import { MainLayout } from "@/components/layout/MainLayout";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

export const Route = createFileRoute("/admin/")({
  head: () => ({
    meta: [
      { title: "Admin | Statlign" },
      { name: "description", content: "Statlign administration console." },
      { property: "og:title", content: "Admin | Statlign" },
      { property: "og:type", content: "website" },
      { property: "og:description", content: "Statlign administration console." },
      { name: "twitter:title", content: "Admin | Statlign" },
      { name: "twitter:description", content: "Statlign administration console." },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => (
    <MainLayout>
      <ProtectedRoute requiredRole="admin">
        <Admin />
      </ProtectedRoute>
    </MainLayout>
  ),
});
